module.exports = __webpack_public_path__ + "img/Linkedin.cf91ca53.gif";